import React, { Component } from 'react';

export default Target => (
  class ClientOnly extends Component {
    static WrappedComponent = Target;

    state = {
      render: false
    }

    componentDidMount() {
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({ render: true });
    }

    render() {
      if (!this.state.render) return null;

      return <Target {...this.props} />;
    }
  }
);



// WEBPACK FOOTER //
// ./src/universal/ui/decorators/client-only.js